import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {EnumLanguage} from "../../enums/EnumLanguage";
import {IPageText} from "../../models/IPageText";
import {UpdatePageTextDto} from "../../api/dto/update-page-text.dto";


interface appState {
    language: EnumLanguage,
    isLoading: boolean,
    isInitialized: boolean
    heightHeader: number,
    pagesText: IPageText[]

}




const initialState: appState = {
    language: EnumLanguage.ru,
    isLoading: true,
    isInitialized: false,
    heightHeader: 0,
    pagesText: []

}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        chooseLanguage(state, action: PayloadAction<EnumLanguage>) {
            localStorage.setItem('language', action.payload)
            state.language = action.payload
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
        setIsInitialized(state, action: PayloadAction<boolean>) {
            state.isInitialized = action.payload
        },
        setHeightHeader(state, action: PayloadAction<number>) {
            state.heightHeader = action.payload
        },
        setPagesText(state, action: PayloadAction<IPageText[]>) {
            state.pagesText = action.payload
        },
        updatePagesText(state, action: PayloadAction<UpdatePageTextDto>) {

            state.pagesText = state.pagesText.map(pageText => {
                if (pageText.id === action.payload.id) {
                    return {
                        ...pageText,
                        text: {
                            ...pageText.text,
                            [action.payload.language]: action.payload.text
                        }

                    }
                }
                return {
                    ...pageText
                }
            })
        }
    }
})

export default appSlice.reducer;